<template>
    <div>
        <div align="right">
            <el-button type="primary" size="mini" @click="dialogVisible = true">
                Create Category
            </el-button>
        </div>
        <el-dialog title="Create Category" :visible.sync="dialogVisible">
            <el-form :model="form" :rules="rules" ref="form" @submit.prevent.native="onSubmit('form')">
                <el-form-item label="Title" prop="title">
                    <el-input v-model="form.title"></el-input>
                </el-form-item>
                <el-form-item label="Group" prop="group">
                    <el-select v-model="form.group" placeholder="Select a group">
                        <el-option v-for="(name, id) in groups" :key="id" :label="name" :value="id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Description" prop="desc">
                    <el-input v-model="form.desc" type="textarea" rows="5"></el-input>
                </el-form-item>
                <el-button native-type="submit" type="primary" :loading="loading">Save</el-button>
                <el-button @click="onCancel('form')">Cancel</el-button>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            dialogVisible: false,
            groups: {
                'cookware': 'Cookware',
                'cutleries': 'Cutleries',
                'utensils': 'Kitchen Utensils',
                'knives': 'Knives',
                'scissors': 'Scissors',
            },
            form: {
                title: null,
                group: null,
                desc: null,
            },
            rules: {
                'title': [
                    { required: true, message: 'Enter the category title.', trigger: 'blur' },
                ],
                'group': [
                    { required: true, message: 'Select the main category.', trigger: 'blur' },
                ],
                'desc': [
                    { required: true, message: 'Enter the category description.', trigger: 'blur' },
                ],
            },
        }
    },

    methods: {
        onSubmit(form) {
            this.loading = true

            this.$refs[form].validate(async valid => {
                if (!valid) {
                    this.loading = false

                    return false
                }

                try {
                    var { data } = await this.$http.post(`/categories`, {
                        title: this.form.title,
                        group: this.form.group,
                        desc: this.form.desc,
                    })
                } catch(err) {
                    this.$message.error(err.response.data.message)

                    return false
                } finally {
                    this.loading = false
                }

                this.$router.push({ name: 'categories-id', params: { id: data.category.id } })
                this.$message.success(data.message)
            })
        },

        onCancel(form) {
            this.dialogVisible = false
            this.$refs[form].resetFields()
        },
    },
}
</script>
